<template>
    <nav class="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-p-3 bg-white tw-shadow-md">
        <div class="tw-flex tw-items-center tw-flex-shrink-0 tw-text-white tw-mr-6">
            <span class="tw-ml-10 tw-font-semibold tw-text-xl tw-tracking-tight">
                <router-link to="/message_type" class="text-white">
                    <img src="../assets/logo.svg" class="tw-h-16" alt="logo" >
                </router-link>
            </span>
        </div>

        <div class="tw-block lg:tw-hidden">
            <button @click="toggle" class="tw-flex tw-items-center tw-px-3 tw-py-2 tw-border tw-rounded tw-text-green-500 tw-border-teal-400 hover:tw-text-black">
            <svg class="tw-fill-current tw-h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
            </button>
        </div>

        <div :class="open ? 'tw-block': 'tw-hidden'" class="tw-w-full tw-block tw-flex-grow lg:tw-flex lg:tw-items-center lg:tw-w-auto">
            <div class="tw-text-sm lg:tw-flex-grow">
                <router-link
                    to="/contact_lists"
                    class="tw-block lg:tw-inline-block tw-text-green-500 mr-4 mb-2 tw-mt-4 lg:tw-mt-0"
                >
                    CONTACT LISTS
                </router-link>
                <router-link
                    to="/callback_number"
                    class="tw-block lg:tw-inline-block tw-text-green-500 mr-4 mb-2 tw-mt-4 lg:tw-mt-0"
                >
                    CALLBACK NO
                </router-link>
                <router-link
                    to="/reports"
                    class="tw-block lg:tw-inline-block tw-text-green-500 mr-4 mb-2 tw-mt-4 lg:tw-mt-0"
                >
                    REPORTS
                </router-link>
                
            </div>
            <button
                class="btn tw-block tw-mr-4 tw-px-5 tw-mt-4 lg:tw-mt-0"
                @click="logout"
            >
                Logout
            </button>
            <router-link
                    to="/account"
                >
                    <img
                        class="tw-mt-4 lg:tw-mt-0"
                        src="../assets/images/user.png"
                        alt="profile"
                        width="40px"
                    >
            </router-link>
        </div>
    </nav>
</template>

<script>
export default {
    name: "NormalHeader",
    data() {
        return {
            open: false,
        }
    },
    methods: {
        toggle() {
            this.open = !this.open
        },
        logout() {
            this.$store.dispatch("logout")
            .then(() => {
                this.$router.push("/login")
            });
        }
    }
}
</script>